import { DIR } from "../../constants/constants";
import { styles } from "./constants";
export enum ROW_TYPE {
  GROUP_HEADER,
  GROUP_ITEM,
  SINGLE_ITEM,
  HEADER,
  SUBTOTAL,
  SUBSTITUTION_TITLE,
  SUBSTITUTION_ROW,
  DISCLAIMER
}

export default class ExcelStylesMPC {

  static borderWidth = styles.BORDER.THICK_BORDER_WIDTH;
  static getCellAlignment() {
    const isRtl = document.dir === DIR.rtl;
    let alignment = !isRtl ? styles.ALIGNMENT.LEFT_ALIGNMENT : styles.ALIGNMENT.RIGHT_ALIGNMENT;
    return {
      horizontal: alignment,
      wrapText: true,
      vertical: styles.ALIGNMENT.MIDDLE_ALIGNMENT,
      indent: !isRtl? styles.INDENT.LTR: styles.INDENT.RTL,
    };
  }

  static addGroupBorder(row) {
    const cellCount = row.cellCount;
    for(let i=1;i<=cellCount;i++) 
      row.getCell(i).border = {
      bottom: {style: this.borderWidth}
    }
  }
  static getStlyes(row_type: ROW_TYPE) {
    let fontColor;
    let fillColor;
    let isBold = false;
    let fontSize = 14;
    switch (row_type) {
      case ROW_TYPE.SUBSTITUTION_ROW:
        fillColor = styles.COLORS.SUBSTITUTION_ROW_BGCOLOR;
        fontColor = styles.COLORS.GROUP_FONT_COLOR;
        break;
      case ROW_TYPE.SUBSTITUTION_TITLE:
        isBold = true;
        fillColor = styles.COLORS.SUBSTITUTION_ROW_BGCOLOR;
        fontColor = styles.COLORS.GROUP_FONT_COLOR;
        break;
      case ROW_TYPE.HEADER:
        fontColor = styles.COLORS.HEADER_CELL_FONT_COLOR;
        fillColor = styles.COLORS.CELL_BGCOLOR;
        break;
      case ROW_TYPE.GROUP_HEADER:
        fillColor = styles.COLORS.GROUP_HEADER_BGCOLOR;
        fontColor = styles.COLORS.GROUP_FONT_COLOR;
        break;
      case ROW_TYPE.GROUP_ITEM:
        fillColor = styles.COLORS.GROUP_BGCOLOR;
        fontColor = styles.COLORS.GROUP_FONT_COLOR;
        break;
      case ROW_TYPE.SINGLE_ITEM:
        fontColor = styles.COLORS.CELL_FONT_COLOR;
        break;
      case ROW_TYPE.DISCLAIMER:
        fontColor = styles.COLORS.GROUP_FONT_COLOR;
        fontSize = 11;
        break;
      default: // Subtotal Row
        fontColor = styles.COLORS.HEADER_CELL_FONT_COLOR;
        fillColor = styles.COLORS.SUBTOTAL_BGCOLOR;
        break;
    }
    return {
      alignment: this.getCellAlignment(),
      font: {
        color: { argb: fontColor },
        size: fontSize,
        bold: isBold,
      },
      fill: {
        fgColor: { argb: fillColor },
        bgColor: { argb: fillColor },
        type: styles.CELL_TYPE,
        pattern: styles.FILL.SOLID_FILL,
      },
      border: {
        top:    { style: styles.BORDER.THIN_BORDER_WIDTH },
        left:   { style: styles.BORDER.THIN_BORDER_WIDTH },
        right:  { style: styles.BORDER.THIN_BORDER_WIDTH },
        bottom: { style: styles.BORDER.THIN_BORDER_WIDTH },
        color:  { argb: styles.COLORS.SUBTOTAL_BGCOLOR }
      }
    }
  }

  private static applyStyle(row, font, alignment, fill = null,border) {
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = font;
      cell.alignment = alignment;
      cell.fill = fill;
      cell.border = border;
    });
  }

  static styleRow(row, rowType: ROW_TYPE) {
    const cellStyles = this.getStlyes(rowType);
    this.applyStyle(row, cellStyles.font, cellStyles.alignment, cellStyles.fill, cellStyles.border);
  }
}
